const state = {
  content: '',
  title: '',
  color: ''
}

const mutations = {
  showMessage (state, payload) {
    state.content = payload.content
    state.title = payload.title
    state.color = payload.color
  }
}

export default {
  namespaced: true,
  state,
  mutations,
}